require('./angulartics-amex-adobe-analytics');
module.exports = 'angulartics.amex.adobe.analytics';



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/modules/angulartics-amex-adobe-analytics/index.js
// module id = 212
// module chunks = 0